import Menu from './Compartido/Menu.jsx';
import TextoPoliticas from './Politicas/TextoPoliticas.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Politicas = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Política-de-Cancelación"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextoPoliticas
                lang={props.lang}
                textopoliticas={props.textopropiedades}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Politicas;

